module.exports = __webpack_public_path__ + "static/media/pdf-search-results-icon.26192199.svg";